import React from 'react';
import Modal from "react-bootstrap/cjs/Modal";
import SproutVideo from "./sprout-video";


const VideoModal: React.FC<{
  show: boolean;
  handleClose:any;
  videoId:string,
  securityToken:string
}> = ({
  show,handleClose,videoId,securityToken
}) => {
     console.log("videoId id",videoId)
     console.log("security_token",securityToken)

  return (
          <Modal className="video-modal" show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
              </Modal.Header>
              <Modal.Body>
                  <SproutVideo
                      id={videoId}
                      security_token={securityToken}
                      skip={0}
                      className="video-modal-content"
                      volume={1}
                      showcontrols={true}
                  />
              </Modal.Body>
          </Modal>

  )
}

export default VideoModal;
